import { combineReducers } from "redux";
import { generalReducer } from "../modules/Layout/reducers";
import {
  appointmentReducer,
  bookingReducer,
  dataSourceReducer,
  configReducer,
  waitingListReducer
} from "../modules/BookingPortal/reducers";
import { personalDetailReducer } from "../modules/ContactForm/reducers";

const rootReducer = combineReducers({
  general: generalReducer,
  appointment: appointmentReducer,
  booking: bookingReducer,
  dataSource: dataSourceReducer,
  config: configReducer,
  personalDetail: personalDetailReducer,
  waitingList: waitingListReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/rootReducer.js